import { Link } from "react-router-dom";
import { LifeBuoy, Mail, Video, BadgePercent, Wallet, HelpCircle } from "lucide-react";
import { PageHeader } from "../../components/Shared";
import { Button } from "../../components/ui/button";

const FAQS = [
  { q: "How do I add a video?", a: "Go to Add Video and paste a YouTube, Instagram Reel, or Facebook video URL. The platform is detected automatically — no uploads needed." },
  { q: "How do I earn money?", a: "Attach an affiliate product/service to your video or share your tracking links. You earn the commission set by the business on every successful sale/booking. Affiliate commission is the only monetization." },
  { q: "When can I withdraw?", a: "Once your commissions are approved and your balance reaches the minimum withdrawal (₹500), add payout details on the Earnings page and request a withdrawal." },
  { q: "Why is my conversion 'Pending'?", a: "Every conversion is reviewed by the MILTROO team before approval. Approved amounts become withdrawable." },
  { q: "Which platforms are supported?", a: "YouTube videos & Shorts, Instagram Reels & posts, and Facebook videos & Reels. Direct video uploads are not supported." },
];

export default function CreatorSupport() {
  return (
    <div className="space-y-8 max-w-3xl" data-testid="creator-support-page">
      <PageHeader title="Support" subtitle="Help for creators — videos, affiliate links & earnings" testid="support-title" />

      <div className="bg-card border border-border rounded-2xl p-6 flex flex-wrap items-center justify-between gap-4" data-testid="support-contact">
        <div className="flex items-center gap-4">
          <div className="h-12 w-12 rounded-2xl flex items-center justify-center" style={{ background: "linear-gradient(135deg,#007A4D,#2563EB)" }}>
            <LifeBuoy className="h-6 w-6 text-white" />
          </div>
          <div>
            <p className="font-display font-bold">Need help?</p>
            <p className="text-sm text-muted-foreground">Our team replies within 24 hours on working days.</p>
          </div>
        </div>
        <a href="mailto:support@miltroo.com"><Button data-testid="support-email-btn" className="rounded-full font-bold gradient-bg text-white border-0"><Mail className="h-4 w-4 mr-1.5" />support@miltroo.com</Button></a>
      </div>

      <div>
        <h2 className="font-display font-bold text-lg mb-3 flex items-center gap-2"><HelpCircle className="h-5 w-5" /> Frequently Asked Questions</h2>
        <div className="space-y-3">
          {FAQS.map((f, i) => (
            <div key={i} data-testid={`support-faq-${i}`} className="bg-card border border-border rounded-2xl p-5">
              <p className="font-display font-bold text-sm">{f.q}</p>
              <p className="text-sm text-muted-foreground mt-1.5">{f.a}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="grid sm:grid-cols-3 gap-4">
        {[
          { to: "/creator/videos/new", icon: Video, t: "Add your first video", testid: "support-goto-add" },
          { to: "/creator/offers", icon: BadgePercent, t: "Browse affiliate offers", testid: "support-goto-offers" },
          { to: "/creator/earnings", icon: Wallet, t: "Check your earnings", testid: "support-goto-earnings" },
        ].map((c) => (
          <Link key={c.to} to={c.to} data-testid={c.testid} className="bg-card border border-border rounded-2xl p-5 hover:shadow-xl hover:-translate-y-1 transition-all flex items-center gap-3">
            <c.icon className="h-5 w-5 text-emerald-600 shrink-0" />
            <span className="font-display font-bold text-sm">{c.t}</span>
          </Link>
        ))}
      </div>
    </div>
  );
}
